import React from 'react'

function PatientActivity() {
  /*
  {
        "id": 9580,
        "clinicId": 5,
        "userId": 5,
        "patientId": 1,

        "mediumType": "SMS", --take
        "reminderType": 21,
        "category": "BIRTHDAY", --take
        
        "queueId": 4048,
        "firstName": "Yashkumar",
        "lastName": "Sompura",
        "preferredName": "Yash",
        "patientName": "Yashkumar Sompura (Yash)",
        "activityName": "Sent Birthday reminder to Yashkumar Sompura (Yash) via SMS", --take
        "extraInfo": null,
        "content": null,
        "hashcode": "e45e1739-1fef-4b32-849e-f402cdeffde1",
        "status": 0, --take
        "createdAt": "2024-04-13T18:46:00",
        "modifiedAt": "2024-04-13T18:46:00"
    }
  */
  
  return (
  <>
    <table className="table table-striped gy-7">
      <thead>
        <tr className='fw-bolder fs-6 text-gray-800'>
          <th>Type</th>
          <th>Category</th>
          <th>Activity Name</th>
          <th>Created</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>SMS</td>
          <td>BIRTHDAY</td>
          <td>Sent Birthday reminder to Yashkumar Sompura (Yash) via SMS</td>
          <td>2024-04-13T18:46:00</td>
        </tr>
      </tbody>
    </table>
  </>
  )
}

export default PatientActivity